<div *ngIf="isQuickThemeSelectEnabled" id="kt_explore_toggle" class="d-flex align-items-center ms-1 ms-lg-3">
    <div [class]="customStyle">
        <i aria-hidden="true" [class]="iconStyle"></i>
    </div>
</div>
